import { getPageWalkthroughs } from '@/api/walkthrough';
import { updateUser } from '@/api/users';
import { walkthroughHelpers } from '@/constants';
import introJs from 'intro.js';

export default {
  computed: {
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async checkPageWalkthroughs() {
      if (!this.isMobile) {
        const { name } = this.$route;
        let page = walkthroughHelpers.find(
          (i) => (i.page === this.pageName || i.routeName === name) && i.category === 'App'
        );
        if (page) {
          const pageWalkthroughs = await getPageWalkthroughs({
            category: 'App',
            page: page.page,
            type: 'Step'
          });
          if (pageWalkthroughs) {
            const steps = pageWalkthroughs.steps
              .map((i) => {
                const element = document.querySelector(`.${i.className}`);
                let hidden = false;
                if (element && page.page === 'App navigation') hidden = element.getClientRects().length === 0;
                return {
                  title: i.title,
                  intro: i.content,
                  tooltipClass: i.tooltipClass,
                  position: i.position && i.position.toLowerCase(),
                  element,
                  hidden
                };
              })
              .filter((i) => !i.hidden);
            const user = Object.assign({}, this.loggedInUser);
            if (!user.completedWalkthroughs) user.completedWalkthroughs = [];
            if (!user.completedWalkthroughs.includes(pageWalkthroughs._id)) {
              introJs()
                .oncomplete(async function () {
                  user.completedWalkthroughs.push(pageWalkthroughs._id);
                  updateUser(user);
                })
                .setOptions({
                  steps,
                  showProgress: true,
                  showBullets: false,
                  exitOnOverlayClick: false
                })
                .start();
            }
          }
        }
      }
    }
  }
};
